"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.send = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const send = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'send-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M15.3009 4.00458L4.18441 4.02803L9.03725 7.69412L15.3009 4.00458ZM8.28807 9.00808L1.50154 3.88116C1.24458 3.68703 1.14023 3.35053 1.24228 3.04507C1.34433 2.73962 1.63 2.53341 1.95205 2.53273L18.0601 2.49875C18.3318 2.49818 18.5767 2.64367 18.7091 2.86987C18.8425 3.09526 18.851 3.37984 18.7188 3.61702L10.8798 17.689C10.723 17.9703 10.4042 18.1202 10.0876 18.0614C9.77093 18.0026 9.52721 17.7481 9.482 17.4293L8.28807 9.00808ZM9.80049 8.98985L10.6542 15.0116L16.0641 5.3003L9.80049 8.98985Z', fill: '#4B5563' })));
};
exports.send = send;
